import { PERSONALINFO } from "../../../util/constants/personalInfo";
import { EmojiProvider, Emoji } from "react-apple-emojis"
import emojiData from "react-apple-emojis/src/data.json"
import { motion,  useScroll,  useTransform } from "framer-motion"
import { useRef } from "react";

function useParallax(value, distance){
    return useTransform(value, [0, 1], [-distance, distance]);
}

export default function AboutMeInfo(){

    /**----------------------
     *    for parallax effect
     *------------------------**/

    const ref = useRef(null);

    const { scrollYProgress } = useScroll({
        target: ref,
        offset: ['start end', 'end start'],
    });

    const imgY = useParallax(scrollYProgress, 100);


    /*---- END OF parallax effect ----*/


    return(
        <>

            <div ref={ref}>


                <div
                    className="
                        flex
                        flex-col
                        justify-center
                        items-center
                        lg:hidden

                        my-10
                        bg-body-bg-light
                        dark:bg-body-bg-dark
                    "
                >


                    {/* /**----------------------
                    *    mobile Image
                    *------------------------**/}
                    <div
                        className="
                            h-[450px]
                            w-[350px]
                            overflow-hidden
                            relative

                        "
                    >
                        <motion.img
                            src={PERSONALINFO.aboutMePic}
                            alt={PERSONALINFO.aboutMePicAlt}
                            className="
                                h-full
                                w-full

                                absolute
                                object-contain

                                top-36
                                right-8

                            "

                            style={{
                                scale: "190%",
                                translateY: imgY,
                            }}
                        />
                    </div>
                    {/*---- END OF mobile Image ----*/}
                    
                    {/* /**----------------------
                    *    mobile text section
                    *------------------------**/}
                    <div
                        className="
                            w-10/12
                            mt-11

                            text-body-text-light
                            dark:text-body-text-dark
                        "
                    >
                        <h3
                            className="
                                text-3xl
                                font-semibold
                            "
                        >
                            Hi, I'm
                        </h3>

                        <h3
                            className="
                                mt-4
                                mb-7
                                font-bold
                                text-5xl
                            "
                        >
                            {
                                PERSONALINFO.firstname
                            }
                        </h3>

                        <p
                            className="
                                leading-7
                                font-normal
                                text-base
                                tracking-wider

                                mb-4
                            "
                            style={{
                                whiteSpace: "pre-line"
                            }}
                        >
                            {
                                PERSONALINFO.aboutMeText
                            }
                        </p>

                        <EmojiProvider 
                            data={emojiData} 
                        >

                            <div
                                className="
                                    flex
                                    justify-start
                                    gap-3
                                "
                            >
                                <Emoji className="inline" name="flag-malaysia" width={24}/>
                                <Emoji className="inline" name="banana" width={24}/>
                                <Emoji className="inline" name="laptop" width={24}/>
                                <Emoji className="inline" name="guitar" width={24}/>

                            </div>
                        </EmojiProvider>
                        

                    </div>
                    {/* /*---- END OF mobile text section----*/ }
                    
                    



                </div>

                <div
                    className="
                        my-10
                        px-[10%]
                        xl:px-[15%]
                        bg-body-bg-light
                        dark:bg-body-bg-dark

                        w-screen

                        flex
                        justify-between

                        items-center

                        max-lg:hidden
                    "
                >

                    {/* /**----------------------
                        *    desktop text section
                        *------------------------**/ }
                    <div
                        className="
                            w-3/6
                            xl:w-5/12
                        "
                    >

                        <h3
                            className="
                                text-3xl
                                font-semibold
                            "
                        >
                            Hi, I'm
                        </h3>

                        <h3
                            className="
                                mt-4
                                mb-7
                                font-bold
                                text-5xl
                            "
                        >
                            {
                                PERSONALINFO.firstname
                            }
                        </h3>


                        <p
                            className="
                                leading-7
                                font-normal
                                text-base
                                tracking-wider

                                mb-4
                            "
                            style={{
                                whiteSpace: "pre-line"
                            }}
                        >
                            {
                                PERSONALINFO.aboutMeText
                            }
                        </p>

                        <EmojiProvider 
                            data={emojiData} 
                        >

                            <div
                                className="
                                    flex
                                    justify-start
                                    gap-3
                                "
                            >
                                <Emoji className="inline" name="flag-malaysia" width={24}/>
                                <Emoji className="inline" name="banana" width={24}/>
                                <Emoji className="inline" name="laptop" width={24}/>
                                <Emoji className="inline" name="guitar" width={24}/>

                            </div>
                        </EmojiProvider>

                    </div>
                    {/* /*---- END OF desktop text section ----*/ }
                    


                    {/* /**----------------------
                    *    desktop Image
                    *------------------------**/}
                    <div
                        className="
                            h-[500px]
                            w-2/6
                            overflow-hidden
                            relative

                        "
                    >
                        <motion.img
                            src={PERSONALINFO.aboutMePic}
                            alt={PERSONALINFO.aboutMePicAlt}
                            className="
                                h-full
                                w-full

                                absolute
                                object-contain
                                scale-[190%]

                                top-36
                                right-8

                            "
                            style={{
                                scale: "190%",
                                translateY: imgY,
                            }}
                        />
                    </div>
                    {/*---- END OF desktop Image ----*/}

                    

                </div>






            </div>



        </>
    );

}